// extracted by mini-css-extract-plugin
export var arrow = "ShareResource-module--arrow--e2f66";
export var arrowNo = "ShareResource-module--arrow_no--3efc5";
export var arrowYes = "ShareResource-module--arrow_yes--ac57d";
export var disabled = "ShareResource-module--disabled--b9e56";
export var emailButton = "ShareResource-module--emailButton--b45c9";
export var emailInput = "ShareResource-module--emailInput--e881f";
export var flex = "ShareResource-module--flex--ffc69";
export var flex1 = "ShareResource-module--flex_1--89f96";
export var flexCenter = "ShareResource-module--flex_center--8f38a";
export var flexCenterCol = "ShareResource-module--flex_center_col--b125f";
export var flexCol = "ShareResource-module--flex_col--78f30";
export var flexFixCenterCol = "ShareResource-module--flex_fix_center_col--4a61d";
export var flexFixedCenterCol = "ShareResource-module--flex_fixed_center_col--70021";
export var rotating = "ShareResource-module--rotating--f6baf";
export var separator = "ShareResource-module--separator--6cf8d";
export var shareButton = "ShareResource-module--shareButton--c9536";
export var shareResourceContainer = "ShareResource-module--shareResourceContainer--b6ff6";
export var shareResourceEmailTitle = "ShareResource-module--shareResourceEmailTitle--7dd82";
export var shareResourceSocialsTitle = "ShareResource-module--shareResourceSocialsTitle--6ec4a";
export var socialShareContainer = "ShareResource-module--socialShareContainer--c42fa";